var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8243 0.175736C16.0373 0.388749 16.0566 0.72208 15.8824 0.956969L15.8243 1.02426L12.5966 4.25192C14.1342 5.33149 15.2834 6.94394 15.7609 8.85151C15.8414 9.17296 15.646 9.49878 15.3246 9.57925C15.0031 9.65972 14.6773 9.46436 14.5968 9.14291C14.1732 7.45078 13.1271 6.03158 11.7327 5.11562L10.285 6.5634C10.851 7.14063 11.2 7.9314 11.2 8.8037C11.2 10.571 9.76731 12.0037 8 12.0037C7.1277 12.0037 6.33693 11.6547 5.7597 11.0887L1.02426 15.8243C0.78995 16.0586 0.41005 16.0586 0.175736 15.8243C-0.0372774 15.6113 -0.0566421 15.2779 0.117641 15.043L0.175736 14.9757L5.06657 10.0844L5.0656 10.0832L10.625 4.52626L10.624 4.5248L11.5306 3.62039L14.9757 0.175736C15.2101 -0.0585786 15.59 -0.0585786 15.8243 0.175736ZM8 2.8C8.80021 2.8 9.57669 2.91846 10.3111 3.14L9.32155 4.12895C8.89291 4.04425 8.45088 4 8 4C4.86155 4 2.15208 6.14421 1.40229 9.14652C1.322 9.46802 0.996284 9.66355 0.674787 9.58326C0.35329 9.50297 0.157754 9.17726 0.238044 8.85576C1.12052 5.32217 4.30759 2.8 8 2.8ZM7.84426 5.60742L4.8032 8.648C4.8846 7.00246 6.20221 5.68611 7.84426 5.60742Z",
    fill: "#B9BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHide);
export default __webpack_public_path__ + "static/media/ic-hide.5a26ef8543eb824bc01f09a8091713c9.svg";
export { ForwardRef as ReactComponent };